import { render, staticRenderFns } from "./JBProposalBusinessNature.vue?vue&type=template&id=4a157a61"
import script from "./JBProposalBusinessNature.vue?vue&type=script&lang=js"
export * from "./JBProposalBusinessNature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports